"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomNavigation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _helpers = require("react-platform-components/dist/helpers");
var _HideOnScroll = require("../HideOnScroll");
var _config = require("../../config");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var BottomNavigation = function BottomNavigation(props) {
  var _props$bottomBarLinks = props.bottomBarLinks,
    bottomBarLinks = _props$bottomBarLinks === void 0 ? [] : _props$bottomBarLinks;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        user: state.auth.user
      };
    }),
    user = _useSelector.user;
  var _useReducer = (0, _react.useReducer)(function (isDrawerOpen) {
      return !isDrawerOpen;
    }, false),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    isDrawerOpen = _useReducer2[0],
    toggleDrawer = _useReducer2[1];
  var bottomBarLinksWithoutDividers = bottomBarLinks.filter(function (link) {
    return link.type !== 'divider';
  });
  var mainLinks = bottomBarLinksWithoutDividers.slice(0, 3);
  var extraLinks = bottomBarLinksWithoutDividers.slice(3);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_HideOnScroll.HideOnScroll, {
    direction: "up"
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    style: {
      width: '100%',
      position: 'fixed',
      bottom: 0
    }
  }, mainLinks.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      key: item.id,
      component: item.component ? item.component : _reactRouterDom.Link,
      to: item.type === 'local' ? "/".concat(item.url) : item.url,
      href: item.url,
      target: item.type === 'external_new_tab' ? '_blank' : '_self',
      icon: item.external_icon_url ? /*#__PURE__*/_react.default.createElement("img", {
        style: {
          height: '1em',
          width: '1em'
        },
        src: (0, _helpers.joinPaths)(_config.BASE_URL, item.external_icon_url),
        alt: item.type
      }) : /*#__PURE__*/_react.default.createElement(_core.Icon, null, item.icon),
      label: item.title
    });
  }), extraLinks.length > 0 && [/*#__PURE__*/_react.default.createElement(_core.Divider, {
    key: "divider-1",
    orientation: "vertical"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    key: "more",
    component: _core.BottomNavigationAction,
    flex: "none",
    icon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "more_vertical"),
    label: "Plus",
    onClick: toggleDrawer
  })])), /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    anchor: "bottom",
    open: isDrawerOpen,
    onClose: toggleDrawer
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    onClick: toggleDrawer,
    onKeyDown: toggleDrawer
  }, /*#__PURE__*/_react.default.createElement(_core.List, null, extraLinks.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      button: true,
      key: item.id,
      component: item.component ? item.component : _reactRouterDom.Link,
      to: item.type === 'local' ? "/".concat(item.url) : item.url,
      href: item.url,
      target: item.type === 'external_new_tab' ? '_blank' : '_self'
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, null, item.external_icon_url ? /*#__PURE__*/_react.default.createElement("img", {
      style: {
        height: '1em',
        width: '1em'
      },
      src: (0, _helpers.joinPaths)(_config.BASE_URL, item.external_icon_url),
      alt: item.type
    }) : /*#__PURE__*/_react.default.createElement(_core.Icon, null, item.icon)), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: item.title
    }));
  })))));
};
exports.BottomNavigation = BottomNavigation;